import { render, staticRenderFns } from "./lkuGolongan.vue?vue&type=template&id=515346b2&"
import script from "./lkuGolongan.vue?vue&type=script&lang=js&"
export * from "./lkuGolongan.vue?vue&type=script&lang=js&"
import style0 from "./lkuGolongan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports